import { useEffect, useState } from 'react';
import { shallow } from 'zustand/shallow';

// Store
import { venusStore } from '@Store/venus';

// Hook
import { valPackage } from '@Hooks/useValidatePlanet';

// Styles
import style from '@Components/Planets/planets.module.scss';
import buttons from '@Sass/components/buttons.module.scss';
import lines from '@Components/Planets/lines.module.scss';

// Images
import _tank from '@Assets/images/tanque.png';
import venus from '@Assets/images/planets/venus.svg';
import _lock from '@Assets/images/lock.png';

export const Venus = ({ venusInfo }) => {
  const [skills, setSkills] = useState([
    {
      skill: '',
    },
    {
      skill: '',
    },
  ]);
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('VENUS');

  // Store de venus
  const { getVenus, dataVenus } = venusStore(
    (state) => ({
      getVenus: state.getVenus,
      dataVenus: state.dataVenus,
    }),
    shallow
  );

  const { validateProject } = valPackage();

  useEffect(() => {
    if (venusInfo.titulo) {
      setSkills(venusInfo.skills);
      setDescription(venusInfo.descripcion);
      setTitle(venusInfo.titulo);
    }
  }, [venusInfo]);

  return (
    <>
      <div>
        <div className={style.cardItem}>
          <div className={style.card_name_tankItem}>
            <h2>{title}</h2>
            <div className={style.card_tank_value}>
              <label>x5</label>
              <img src={_tank} alt="tank" />
            </div>
          </div>
          <div className={`${style.planetImage_content} ${lines.lines_venus} `}>
            <div className={lines.lines_venus_1}>
              <p>{skills[0].skill}</p>
            </div>
            <div className={lines.lines_venus_2}>
              <p>{skills[1].skill}</p>
            </div>
            {getVenus().lockedPlanet === 'desbloqueado' ? (
              <></>
            ) : (
              <img src={_lock} alt="lock" className={style.imgLock} />
            )}
            <img src={venus} alt="planet" className={`${style.planetImage}  ${style.venus}`} />
          </div>
          <div className={style.planetInfo}>
            <p>{description}</p>
          </div>
          <div className={style.planetButton_content}>
            {getVenus().id ? (
              <button
                className={`${
                  dataVenus.complete === 1
                    ? buttons.buttonPlanetCompleted
                    : dataVenus.complete === 2
                    ? buttons.buttonPlanetIncomplete
                    : dataVenus.complete === 0
                    ? buttons.buttonPlanet
                    : buttons.buttonPlanet
                }`}
                onClick={() => validateProject('venus', 5)}
              >
                {dataVenus.label}
              </button>
            ) : (
              <button className={style.moon_launchBtn} onClick={() => validateProject('venus', 5)}>
                ACCEDER
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
